
import { Component, Prop } from 'nuxt-property-decorator'

import { createAmpOfferInstance, HomeOffer } from '@alao-frontend/core'

import BPSectionHeader from '../snippets/BPSectionHeader.vue'
import BPDealsGrid from './BPDealsGrid.vue'
import SimpleOfferCard from '~/components/offers/SimpleOfferCard/SimpleOfferCard.vue'

import { $api } from '~/plugins/axios'
import { OffersListAnalyticsMixin } from '~/mixins/offers-list-analytics.mixin'
import { AlButton } from '~/components/ui'
import { getExternalCompareHomeHref, getExternalIndexHref } from '~/utils/external-links.utils'

@Component({
  components: {
    AlButton,
    BPSectionHeader,
    BPDealsGrid,
    SimpleOfferCard,
  },
})
export default class BPHomeDeals extends OffersListAnalyticsMixin {
  @Prop({ type: String, required: true })
  title!: string

  @Prop({ type: String, required: true })
  subTitle!: string

  isOffersLoading = true
  offers: HomeOffer[] = []

  get externalCompareHomeHref (): string {
    return getExternalCompareHomeHref(this.$config.BASE_URL, this.localePath)
  }

  async fetchOffers () {
    this.isOffersLoading = true

    try {
      this.offers = (await $api.PublicOfferService.searchOffers({
        product_type: 'home',
        limit: 4,
      })).items.map(item => createAmpOfferInstance(item))

      this.isOffersLoading = false
    } catch (error: any) {
      this.$notify({
        title: 'Error',
        message: error.message,
        duration: 3000,
      })
    }
  }

  async mounted (): Promise<void> {
    await this.fetchOffers()
  }
}
